import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { EventAggregator } from 'aurelia-event-aggregator';
import { StoreFocusEvent, ReturnFocusEvent } from 'app/shared/lib/events';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssCardPage extends ComponentBase {
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(
        private readonly events: EventAggregator,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////
    ////****************** Example 2 ********************************************////
    protected ex2Content: string | null = 'Card Content';

    ////****************** Example 3 ********************************************////
    protected ex3Header: string | null = 'Card Slot Header 3';
    protected ex3Content: string | null = 'Card Content';
    protected ex3Footer: string | null = 'Card Footer';
    protected ex3ExampleLink: boolean = true;

    protected handleLinkEvents(): boolean {
        this.events.publish(new StoreFocusEvent());

        return true;
    }

    // NOTE: [EN] Do NOT use this function's setTimeout, this is for mocking up the returning of focus when back button is clicked on ess-card. Due to demo page not changing page nor calls upon updated info. Event publish of ReturnFocusEvent should be applied after page or api content is loaded.
    protected handleCardClickEvent(): void {
        setTimeout(() => { this.events.publish(new ReturnFocusEvent()); }, 2000);
        return;
    }

    ////****************** Example 4 ********************************************////
    protected ex4Header: string = 'Card Slot Header 4';
    protected ex4SubHeader: string = 'Slot Sub Header';
    protected ex4Content: string = 'Default Slot Content';
    protected ex4Footer: string = 'Slot Footer';

}
